import { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

function Autocomplete(props) {
    const inputRef = useRef(null);
   
    const [inputValue, setInputValue] = useState(props.initialValue || "");
    const [predictions, setPredictions] = useState([]);
    const [sessionToken, setSessionToken] = useState(null);

    useEffect(() => {
        // init sessionToken for use input session
        const token = new window.google.maps.places.AutocompleteSessionToken();
        setSessionToken(token);
    }, []);
    // handle inputValue update in second useEffect - avoids unnecesary sessionToken refresh
    useEffect(() => {
        setInputValue(props.initialValue || "");
    }, [props.initialValue]);


    const fetchPredictions = async (input) => {
        if (!input) {
            setPredictions([]);
            return;
        }

        try {
            const { AutocompleteSuggestion } = window.google.maps.places;
            const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions({
                input,
                sessionToken,
                region: "de" // TODO use existing region limit
            });

            setPredictions(suggestions || []);
        } catch (error) {
            setPredictions([]);
        }
    };

    const handleChange = (e) => {
        const val = e.target.value;
        setInputValue(val);
        fetchPredictions(val);
        props.onChange?.(e);
    };

    const handleSelect = async (suggestion) => {
        try {
            const place = await suggestion.placePrediction.toPlace();
            // console.log("Autocomplete handleSelect fields: ", props.fields);
            await place.fetchFields({ fields: props.fields });
            // console.log("Autocomplete place: ", place);
            const line1 = place.displayName || "";
            setInputValue(line1);
            setPredictions([]);

            props.onPlaceSelected(line1, place);

            // after selection, create a new session token for the next input session
            const newToken = new window.google.maps.places.AutocompleteSessionToken();
            setSessionToken(newToken);
        } catch (err) {
            console.error("Error selecting place:", err);
        }
    };

    return (
        <>
            <input
                id={props.id}
                className={props.className}
                ref={inputRef}
                name={props.name}
                onKeyUp={props.onKeyUp}
                defaultValue={props.initialValue}
                onChange={handleChange}
                type="text"
                value={inputValue}
                autoComplete="off"
            />
            {predictions.length > 0 && (
                <ul
                    className="autocomplete-dropdown"
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        zIndex: 1000,
                        background: "white",
                        border: "1px solid #ccc",
                        margin: 0,
                        padding: 0,
                        listStyle: "none",
                        maxHeight: "200px",
                        overflowY: "auto"
                    }}
                >
                    {predictions.map((pred, index) => (
                        <li
                            key={index}
                            onClick={() => handleSelect(pred)}
                            style={{ padding: "8px", cursor: "pointer" }}
                        >
                            {pred.placePrediction.text.text}
                        </li>
                    ))}
                </ul>
            )}
        </>
    );
}

Autocomplete.propTypes = {
    onPlaceSelected: PropTypes.func.isRequired,
    id: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    fields: PropTypes.arrayOf(PropTypes.string),
    types: PropTypes.arrayOf(PropTypes.string),
    componentRestrictions: PropTypes.object,
    onChange: PropTypes.func,
    initialValue: PropTypes.string,
    onKeyUp: PropTypes.func
};

Autocomplete.defaultProps = {
    fields: ["displayName", "formattedAddress", "location", "addressComponents"],
    types: ["address"] // TODO invalid in new API
};

export default Autocomplete;
